package com.mencanhealth.admin.ui

import androidx.compose.runtime.*
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.dom.*

@Composable
fun LoginPage(
    isLoading: Boolean,
    error: String?,
    onSignIn: (String, String) -> Unit
) {
    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }

    Div({ classes("login-container") }) {
        Div({ classes("login-card") }) {
            H1 { Text("NutriMX Admin") }
            P({ classes("login-subtitle") }) { Text("Dashboard de administración") }

            error?.let {
                Div({ classes("error-banner") }) { Text(it) }
            }

            Div({ classes("form-group") }) {
                Label { Text("Email") }
                Input(InputType.Email) {
                    classes("form-input")
                    value(email)
                    onInput { email = it.value }
                    attr("placeholder", "admin@nutrimx.com")
                }
            }
            Div({ classes("form-group") }) {
                Label { Text("Password") }
                Input(InputType.Password) {
                    classes("form-input")
                    value(password)
                    onInput { password = it.value }
                    onKeyDown {
                        if (it.key == "Enter" && !isLoading) onSignIn(email, password)
                    }
                }
            }
            Button({
                classes("btn-primary")
                if (isLoading) attr("disabled", "true")
                onClick { onSignIn(email, password) }
            }) {
                Text(if (isLoading) "Signing in..." else "Sign In")
            }
        }
    }
}
